<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ initialized ? data.title : 'Loading...' }}</h1>

<div mat-dialog-content class="mbp-confirm-dialog__content individual-search-dialog">
  @if (!initialized) {
    <mat-progress-bar mode="buffer"></mat-progress-bar>
  }
  @if (initialized) {
    <div class="individual-search-dialog__filters">
      <mat-form-field appearance="outline" class="individual-search-dialog__search" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          type="text"
          placeholder="Individual name"
          aria-label="Individual name"
          [formControl]="individualNameFilterControl"
        />
      </mat-form-field>
    </div>

    <mat-paginator
      class="individual-search-dialog__paginator"
      [length]="totalNumberOfIndividuals"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [pageSizeOptions]="[10, 15, 20]"
      showFirstLastButtons
      (page)="onPageChange($event)"
      aria-label="Select page of individuals"
    >
    </mat-paginator>

    <div class="mbp-table-wrap">
      <table mat-table [dataSource]="individualsDataSource" class="mbp-data-table individual-list">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let selectable">{{ selectable.individual.title }}</td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="name-col">Name</th>
          <td mat-cell *matCellDef="let selectable" class="name-col">
            {{ selectable.individual.first_name + ' ' + selectable.individual.last_name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let selectable">{{ getIndividualType(selectable.individual) }}</td>
        </ng-container>
        <ng-container matColumnDef="contact">
          <th mat-header-cell *matHeaderCellDef>Contact</th>
          <td mat-cell *matCellDef="let selectable">{{ selectable.individual.phone_number }}</td>
        </ng-container>
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let selectable">{{ getCreationTime(selectable.individual) }}</td>
        </ng-container>
        <ng-container matColumnDef="selected">
          <th mat-header-cell *matHeaderCellDef class="selected-col">Selected</th>
          <td mat-cell *matCellDef="let selectable" class="selected-col">
            <span class="individual-search-dialog__checkbox">
              <mat-checkbox
                [disableRipple]="true"
                (click)="$event.preventDefault()"
                color="primary"
                [checked]="selectable.selected"
              >
              </mat-checkbox>
            </span>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          class="individual-search-dialog__row"
          [class.selected]="row.selected"
          (click)="selectIndividual(row)"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
  }
</div>

<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button type="button" mat-stroked-button [mat-dialog-close]="null">Cancel</button>
  <button
    type="button"
    mat-flat-button
    [disabled]="!selectedIndividual || isLoading"
    [mat-dialog-close]="selectedIndividual"
    color="primary"
    cdkFocusInitial
  >
    Apply
  </button>
</div>
